import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Member } from "../../services/api/types/Members";
import { useMemberArray } from "../../services/hooks/MembersList";

interface MemberListState {
  members: Array<Member>;
}

const initialState: MemberListState = {
  members: [],
};

export const memberListSlice = createSlice({
  name: "MemberList",
  initialState,
  reducers: {
    setMembers: (state, action: PayloadAction<Array<Member>>) => {
      state.members = action.payload;
    },
    pullMembers: state => {
      useMemberArray().then(members => (state.members = members));
    },
  },
});

export const { setMembers, pullMembers } = memberListSlice.actions;
